import { render, staticRenderFns } from "./EmrDataList.vue?vue&type=template&id=0a16c9a1&scoped=true&"
import script from "./EmrDataList.vue?vue&type=script&lang=js&"
export * from "./EmrDataList.vue?vue&type=script&lang=js&"
import style0 from "./EmrDataList.vue?vue&type=style&index=0&id=0a16c9a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a16c9a1",
  null
  
)

export default component.exports